import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Logo";
import { api } from "@/lib/api";

export const ResultShell = ({ icon, title, text, testid, children }) => (
  <div className="grid min-h-screen place-items-center bg-[#FAF7F2] px-4">
    <div data-testid={testid} className="w-full max-w-lg rounded-2xl border border-[#E8E1D7] bg-white p-10 text-center shadow-sm">
      <div className="mb-8"><Logo /></div>
      <div className="flex justify-center">{icon}</div>
      <h1 className="mt-6 text-3xl font-bold text-[#1E1A17]">{title}</h1>
      <p className="mt-3 text-[#6E655F]">{text}</p>
      <div className="mt-8">{children}</div>
    </div>
  </div>
);

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") return setState("paid");
        if (data.status === "expired") return setState("error");
      } catch { return setState("error"); }
      if (++tries >= 10) return setState("timeout");
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  const back = <Button asChild className="rounded-full bg-[#1E1A17] px-6 hover:bg-[#E05A47]" data-testid="payment-back-home"><Link to="/">Volver al inicio</Link></Button>;

  if (state === "checking")
    return <ResultShell testid="payment-checking" icon={<Loader2 className="h-14 w-14 animate-spin text-[#E05A47]" />} title="Confirmando tu pago…" text="Esto tarda solo unos segundos." />;
  if (state === "paid")
    return <ResultShell testid="payment-success" icon={<CheckCircle2 className="h-14 w-14 text-[#2A9D8F]" />} title="¡Pago confirmado! Bienvenida" text="Gracias por confiar en LATINA DIGITAL IA. En menos de 24 h te escribimos por email para agendar tu sesión de arranque.">{back}</ResultShell>;
  return <ResultShell testid="payment-error" icon={<XCircle className="h-14 w-14 text-[#E05A47]" />} title="No pudimos confirmar el pago" text="Si se realizó el cargo, te contactaremos igualmente. Si tienes dudas, escríbenos por WhatsApp.">{back}</ResultShell>;
}
